export const TRIAL_COLORS = {
  darkText: '#292E36',
  darkBoldText: '#12151A',
  lightGrey: '#e0e6ee',
  lightGreyText: '#555c67',
  grey: '#9EA9B8',
  validGreen: '#48C78C',
};
